
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engineering-program",
      function () {
        return require("private-next-pages/engineering-program.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engineering-program"])
      });
    }
  